import { css } from 'lit';

// language=CSS
export const input =
    css`
        input[type="text"],
        input[type="number"],
        input[type="password"],
        input[type="datetime-local"] {
            display: block;
            height: 2.81rem;
            padding: 0.19rem 0.625rem;
            width: 100%;
            background-color: #fff;
            border: 0.06rem solid #f5f5f5;
            box-shadow: var(--sp-default-box-shadow);
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            font-family: "EkMukta-Light";
            font-size: 0.875rem;
            color: #000;
            border-radius: 0.19rem;
        }

        input[type="datetime-local"] {
            line-height: 2.81rem;
        }

        input:focus {
            background-color: #eaedef;
            border: 0.06rem solid #fff;
            box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.075);
        }
    `;
